/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Link } from 'react-router-dom';

class HeaderTabDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  get initialState() {
    return {
      AccountDownArrow: true,
      TechnologyDownArrow: true,
      FinanceDownArrow: true,
      SkillsDownArrow: true,
      AdmissionsDownArrow: true,
    };
  }

  render() {
    const menu = this.props.data;
    return (
      <div className="container-fluid product-dropdown-tablet">
        <div className="collapse show productsPanel" id="productsCollapse">
          <div className="card">
            <div className="panel-group" id="accordionOne" role="tablist" aria-multiselectable="true">
              {menu.child_items.map((item) => (
                <React.Fragment key={item.title}>
                  {item.title === 'Accounting'
                  && (
                  <div className="card-body expolre-cards panel panel-default">
                    <div className="panel-heading" role="tab" id="headingOne">
                      <h4 className="panel-title">
                        <a
                          role="button"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="false"
                          aria-controls="collapseOne"
                          onClick={() => this.setState((prevState) => (
                            {
                              ...this.initialState,
                              AccountDownArrow: !prevState.AccountDownArrow,
                            }))}
                        >
                          {item.title}
                          <span className={`arrow ${this.state.AccountDownArrow ? 'fa fa-chevron-down'
                            : 'fa fa-chevron-up'}`}
                          />
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseOne"
                      className="panel-collapse collapse in"
                      role="tabpanel"
                      data-parent="#accordionOne"
                      aria-labelledby="headingOne"
                    >
                      <div className="panel-body">
                        <ul className="list-group accordion-content">
                          {item.child_items.map((child) => (
                            <li className="list-group-item" key={child.title}>
                              {(child.url.indexOf('http://') === 0 || child.url.indexOf('https://') === 0)?
                              <a href={child.url}>{child.title}</a>:
                              <Link to={child.url}>{child.title}</Link>
                              }
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  )}
                  {item.title === 'Technology'
                  && (
                  <div className="card-body expolre-cards panel panel-default">
                    <div className="panel-heading" role="tab" id="headingTwo">
                      <h4 className="panel-title">
                        <a
                          className="collapsed"
                          role="button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                          onClick={() => this.setState((prevState) => (
                            {
                              ...this.initialState,
                              TechnologyDownArrow: !prevState.TechnologyDownArrow,
                            }))}
                        >
                          {item.title}
                          <span className={`arrow ${this.state.TechnologyDownArrow ? 'fa fa-chevron-down'
                            : 'fa fa-chevron-up'}`}
                          />
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseTwo"
                      className="panel-collapse collapse"
                      role="tabpanel"
                      data-parent="#accordionOne"
                      aria-labelledby="headingTwo"
                    >
                      <div className="panel-body">
                        <ul className="list-group">
                          {item.child_items.map((child) => (
                            <li className="list-group-item" key={child.title}>
                              {(child.url.indexOf('http://') === 0 || child.url.indexOf('https://') === 0)?
                              <a href={child.url}>{child.title}</a>:
                              <Link to={child.url}>{child.title}</Link>
                              }
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  )}
                  {item.title === 'Finance'
                  && (
                  <div className="card-body expolre-cards panel panel-default">
                    <div className="panel-heading" role="tab" id="headingThree">
                      <h4 className="panel-title">
                        <a
                          className="collapsed"
                          role="button"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="true"
                          aria-controls="collapseThree"
                          onClick={() => this.setState((prevState) => (
                            {
                              ...this.initialState,
                              FinanceDownArrow: !prevState.FinanceDownArrow,
                            }))}
                        >
                          {item.title}
                          <span className={`arrow ${this.state.FinanceDownArrow ? 'fa fa-chevron-down'
                            : 'fa fa-chevron-up'}`}
                          />
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseThree"
                      className="panel-collapse collapse"
                      role="tabpanel"
                      data-parent="#accordionOne"
                      aria-labelledby="headingThree"
                    >
                      <div className="panel-body">
                        <ul className="list-group">
                          {item.child_items.map((child) => (
                            <li className="list-group-item" key={child.title}>
                              {(child.url.indexOf('http://') === 0 || child.url.indexOf('https://') === 0)?
                              <a href={child.url}>{child.title}</a>:
                              <Link to={child.url}>{child.title}</Link>
                              }
                            </li>
                          ))}
                        </ul>
                        {/* </p> */}
                      </div>
                    </div>
                  </div>
                  )}
                  {item.title === 'Business Skills'
                  && (
                  <div className="card-body expolre-cards panel panel-default">
                    <div className="panel-heading" role="tab" id="headingFour">
                      <h4 className="panel-title">
                        <a
                          className="collapsed"
                          role="button"
                          data-toggle="collapse"
                          data-target="#collapseFour"
                          aria-expanded="true"
                          aria-controls="collapseFour"
                          onClick={() => this.setState((prevState) => (
                            {
                              ...this.initialState,
                              SkillsDownArrow: !prevState.SkillsDownArrow,
                            }))}
                        >
                          {item.title}
                          <span className={`arrow ${this.state.SkillsDownArrow ? 'fa fa-chevron-down'
                            : 'fa fa-chevron-up'}`}
                          />
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseFour"
                      className="panel-collapse collapse"
                      role="tabpanel"
                      data-parent="#accordionOne"
                      aria-labelledby="headingFour"
                    >
                      <div className="panel-body">
                        <ul className="list-group">
                          {item.child_items.map((child) => (
                            <li className="list-group-item" key={child.title}>
                              {(child.url.indexOf('http://') === 0 || child.url.indexOf('https://') === 0)?
                              <a href={child.url}>{child.title}</a>:
                              <Link to={child.url}>{child.title}</Link>
                              }
                            </li>
                          ))}
                        </ul>
                        {/* </p> */}
                      </div>
                    </div>
                  </div>
                  )}
                  {item.title === 'Admissions'
                  && (
                  <div className="card-body expolre-cards panel panel-default">
                    <div className="panel-heading" role="tab" id="headingFive">
                      <h4 className="panel-title">
                        <a
                          className="collapsed"
                          role="button"
                          data-toggle="collapse"
                          data-target="#collapseFive"
                          aria-expanded="true"
                          aria-controls="collapseFive"
                          onClick={() => this.setState((prevState) => (
                            {
                              ...this.initialState,
                              AdmissionsDownArrow: !prevState.AdmissionsDownArrow,
                            }))}
                        >
                          {item.title}
                          <span className={`arrow ${this.state.AdmissionsDownArrow ? 'fa fa-chevron-down'
                            : 'fa fa-chevron-up'}`}
                          />
                        </a>
                      </h4>
                    </div>
                    <div
                      id="collapseFive"
                      className="panel-collapse collapse"
                      role="tabpanel"
                      data-parent="#accordionOne"
                      aria-labelledby="headingFive"
                    >
                      <div className="panel-body">
                        <ul className="list-group">
                          {item.child_items.map((child) => (
                            <li className="list-group-item" key={child.url}>
                              {(child.url.indexOf('http://') === 0 || child.url.indexOf('https://') === 0)?
                              <a href={child.url}>{child.title}</a>:
                              <Link to={child.url}>{child.title}</Link>
                              }
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderTabDropdown;
